<template>
  <lazy-display-frozenpanetable-xy
    :nbx="100000"
    :nby="100000000"
    :default_width="100"
    :variable_width_start_pos="variable_width_start_pos"
    :variable_widthss="variable_widths"
    :default_height="20"
    :variable_height_start_pos="variable_height_start_pos"
    :variable_heights="variable_heights"
    :horizontal_header_height="20"
    :vertical_header_width="100"
    class="w-100"
    style="height: 720px;"
  >
    <template #horizontalheader="{nbx, width}">
      <div :key="nbx" :style="width" class="d-inline-block">{{ nbx }}</div>
    </template>
    <template #verticalheader="{nby, height}">
      <div :key="nby" :style="height">{{ nby }}</div>
    </template>
    <template #bodycell="{nbx, nby, width, height}">
      <div :key="`${nbx}x${nby}`" :style="width + height">
        {{ nbx }}x{{ nby }}
      </div>
    </template>
  </lazy-display-frozenpanetable-xy>
</template>

<script>
import _ from 'lodash'

import Vue from 'vue'

import LazyDisplayFrozenpanetableXy from '@/components/lazy_display_frozenpanetable_xy.vue'

// *****************************************************************************

export default {
  name: 'TestLazyDisplayFrozenpanetableXy',

  components: {
    LazyDisplayFrozenpanetableXy,
  },

  data() {
    return {
      variable_width_start_pos: undefined,
      variable_widths: undefined,
      variable_height_start_pos: undefined,
      variable_heights: undefined,
    }
  },
}
</script>
